import { create } from 'zustand';
import type { ConfigResponse, GroupId, SpaceSnapshot } from './types';

interface AppState {
  config?: ConfigResponse;
  deviceKey?: string;
  snapshot?: SpaceSnapshot;
  groupId?: GroupId;
  currentIndex: number;
  turnstileToken?: string;
  presence: number;
  setConfig: (config: ConfigResponse) => void;
  setDeviceKey: (deviceKey: string) => void;
  setSnapshot: (snapshot: SpaceSnapshot) => void;
  setGroupId: (groupId: GroupId) => void;
  setTurnstileToken: (token?: string) => void;
  setPresence: (presence: number) => void;
  next: () => void;
}

export const useAppStore = create<AppState>((set) => ({
  currentIndex: 0,
  presence: 0,
  setConfig: (config) => set({ config }),
  setDeviceKey: (deviceKey) => set({ deviceKey }),
  setSnapshot: (snapshot) => set({ snapshot }),
  setGroupId: (groupId) => set({ groupId }),
  setTurnstileToken: (turnstileToken) => set({ turnstileToken }),
  setPresence: (presence) => set({ presence }),
  next: () => set((state) => ({ currentIndex: state.currentIndex + 1, turnstileToken: undefined }))
}));
